import { Button } from '@/components/ui/button';
import { TypographyP } from '@/components/ui/typography';
import { mutualLinkStyle } from '@/blocks/Footer';
import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';
import { cn } from '@/lib/utils';

import { passButtonIcons } from '@/components/atoms/Button/utils';
import { transformLinkToButtonProps } from '@/components/atoms/LinkButton/utils';
import CookiePolicyLink from './CookiePolicyLink';
import { isCookiePolicyLink } from './utils';

type FooterCategory = {
  title: string;
  links: LinkButtonStrapiProps[];
};

export type FooterCategoriesProps = {
  categories: FooterCategory[];
};

const FooterCategories = ({ categories }: FooterCategoriesProps) => {
  return (
    <div className='flex flex-1 flex-wrap gap-10 md:gap-[60px]'>
      {categories.map((category, index) => (
        <div key={index} className='flex w-[200px] flex-col gap-6'>
          <TypographyP className='text-label-medium font-mono uppercase text-gray-500 dark:text-gray-dark-400 mt-0'>
            {category.title}
          </TypographyP>
          <div className='flex flex-col gap-3'>
            {category.links.map((link, linkIndex) => {
              if (isCookiePolicyLink(link)) {
                return <CookiePolicyLink key={linkIndex} link={link} />;
              }

              const linkProps = transformLinkToButtonProps(link);
              return (
                <Button
                  key={linkIndex}
                  as={linkProps.element as 'a' | 'nextlink' | 'button'}
                  variant='text'
                  color='primary'
                  slim
                  textWrap
                  classNames={{
                    root: cn(
                      mutualLinkStyle,
                      'hover:bg-transparent active:bg-transparent font-normal'
                    ),
                  }}
                  {...passButtonIcons(link)}
                  {...linkProps}
                >
                  {link.text}
                </Button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FooterCategories;
